import axios from 'axios';

const instance = axios.create({

    
    baseURL: 'https://okancelik.com.tr/api/admin/'
});

export default instance;